import {
    AssignmentType,
    ContainerType,
    SingleValueDataType,
    TaskConfigType,
    ValueTypeDefinitions,
} from './Tasks.types'

export enum ExamEvaluationStatus {
    COMPLETED = 'COMPLETED',
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
}

export enum ExamResult {
    PASS = 'PASSED',
    FAIL = 'FAILED',
    SUBMITTED = 'SUBMITTED',
}

export enum AttemptStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    INCOMPLETE = 'INCOMPLETE',
}

export enum ExamType {
    EXAM = 'EXAM',
    TRAINING = 'TRAINING',
}

export type ExamAttempt = {
    created_at: string
    id: string
    status: AttemptStatus
}

export type ExamResponseType = {
    id: string
    name: string
    project: {
        nickname: string
        description: string
    }
    time_limit_in_seconds: number | null
    num_of_questions: number
    attempt: ExamAttempt | null
}

export type ExamListResponseType = {
    exams: ExamResponseType[]
}

export type ExamDetailResponseType = {
    exam: {
        attempt: ExamAttempt | null
        name: string
        instruction: {
            content: string
        }
        num_of_questions: number
        time_limit_in_seconds: number | null
        attempts_remaining: number
        type: ExamType
        is_archived: boolean
    }
}

export type AttemptHistory = {
    exam: {
        name: string
        show_result: boolean
    }
    id: string
    attempt_number: number
    completed_at: number | null
    evaluation_status: ExamEvaluationStatus
    result: {
        AttemptResult: ExamResult
    } | null
}

export type AttemptHistoryResponseType = {
    attempts: AttemptHistory[]
}

export type CreateAttemptResponseType = {
    attempt_id: string
}

export type GetAttemptResponseType = {
    attempt: {
        id: string
        attempting_question_index: number
        created_at: string
        status: AttemptStatus
        answers: { id: string }[]
        attempt_number: number
        exam: {
            attempts_remaining: number
            cutoff_score: number
            id: string
            time_limit_in_seconds: number | null
            type: ExamType
            name: string
            is_archived: boolean
            show_result: boolean
        }
        evaluation_status: ExamEvaluationStatus
        result: ExamResult | null
        score: number
    }
}

export type SubmitAttemptResponseType = object

export type GetExamAssignmentResponseType = {
    assignment: AssignmentType<ContainerType, unknown>
}

export type ExamInfoType = {
    answerId: string
    totalQuestions: number
    currentQuestion: number
    timeLimit?: number
}

export type GetQuestionPreviewResponseType = {
    assignment: AssignmentType<ContainerType, unknown>
    evaluation_info: {
        attribute_evaluations: {
            attribute_id: string
            correct_value: SingleValueDataType<keyof ValueTypeDefinitions>
            feedbacks_info: {
                correct_value_feedback: string
                incorrect_value_feedback: string
            } | null
        }[]
    }
    exam_info: { type: ExamType }
}

export type ExamPreviewConfigType = TaskConfigType<ContainerType, unknown> & {
    evaluationInfo: GetQuestionPreviewResponseType['evaluation_info']
}

export type AttributeFeedbackType = {
    id: string
    is_correct: boolean
    feedback: string
    correct_answer?: SingleValueDataType<'STRING' | 'STRING_ARRAY' | 'INT'>['value']
}

export type GetQuestionFeedbackResponseType = {
    result: Omit<AttributeFeedbackType & { attribute_version_id: string }, 'id'>[]
}
